import React from 'react';
import { Typography, Descriptions,Space} from 'antd';

const { Paragraph } = Typography;

const Zja = (props) => {
 const { jname, onuTest} = props;
const bangm =jname;

  const items = [
    {
      label: '用户账号',
      children:<Space>{bangm.u_name}</Space>,
    },
    {
      label: '联系电话',
      children: bangm.u_phone,
    },
    {
      label: '钱包余额',
      children: <Space onClick={()=>{onuTest('chongzhi')}}>{bangm.u_qb}</Space>,
    },
    {
      label: '营销余额',
      children: <span>{bangm.yx_ye}</span>,
    },
    {
      label: '到期时间',
      children: <Space onClick={()=>{onuTest('xufei')}}>{bangm.dq_time}</Space>,
    },

    //<TransactionOutlined />
    {
      label: '认证余次',
      children: <Space onClick={()=>{onuTest('renzheng')}} >{bangm.rz_s}</Space>,
    },
    {
      label: '胜券余额',
      children: <Space onClick={()=>{onuTest('shengquandh')}} >{bangm.dq_ye}</Space>,
    },
   
    {
      label: '产品数量',
      children: <Space onClick={()=>{onuTest('shouyitixian')}}>{bangm.hzlb}</Space>,
    },
    {
      label: '数据总量',
      children: <Space onClick={()=>{onuTest('shouyitixian')}}>{bangm.hznum}</Space>,
    },
     {
      label: '推广收益',
      children: <Space onClick={()=>{onuTest('shouyitixian')}}>{bangm.tg_sy}</Space>,
    },
    {
      label: '推广链接',
      children: <Paragraph copyable>{'http://www.ddspp.com/?t=' + bangm.uid}</Paragraph>,
    },
    // {
    //   label: '业务链接',
    //   children: <Paragraph copyable>{'http://www.ddspp.com/wap/?td=m_v2&uid=' + bangm.uid}</Paragraph>,
    // },


  ];

  return (<>
    { true && <Descriptions items={items} />}
    </>);
};
export { Zja}